/**
 * Calculate the Estimated Monthly Installment (EMI) for a mortgage,
 * taking into account an up-front down payment.
 *
 * @param propertyPrice         – Total property price
 * @param downPayment           – Up-front down payment
 * @param annualInterestRate    – Annual interest rate in percent (e.g. 7.5 for 7.5%)
 * @param termYears             – Loan term in years
 * @returns                     – The monthly installment amount
 */
export function calculateKPA(
  propertyPrice: number,
  downPayment: number,
  annualInterestRate: number,
  termYears: number
): number {
  const loanAmount = propertyPrice - downPayment;
  const monthlyRate = annualInterestRate / 12 / 100;
  const totalMonths = termYears * 12;

  if (monthlyRate === 0) {
    return loanAmount / totalMonths;
  }

  const payment =
    (loanAmount * monthlyRate) /
    (1 - Math.pow(1 + monthlyRate, -totalMonths));

  return payment;
}
